import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4SearchEventProps extends GA4GeneralProps {
  searchTerm: string
  resultPage: number | null
  totalReturnedResults: number
  answeredByStatic?: boolean | null
  searchMethod?: string | null
}

export class GA4SearchEvent extends GA4Event {
  ga4_search_term: string
  ga4_result_page: number | null
  ga4_answered_by_static: boolean | null
  ga4_total_returned_results: number
  ga4_search_method: string | null

  constructor({
    searchTerm,
    resultPage = null,
    totalReturnedResults,
    answeredByStatic = null,
    searchMethod = null,
    ...generalProps
  }: GA4SearchEventProps) {
    super({ event: EVENT.SEARCH, ...generalProps })

    this.ga4_search_term = searchTerm
    this.ga4_result_page = resultPage
    this.ga4_total_returned_results = totalReturnedResults
    this.ga4_answered_by_static = answeredByStatic
    this.ga4_search_method = searchMethod
  }
}
